import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import ReactModal from 'react-modal';

import { EquipmentInfoRequest } from 'api/DeviceRequest';
import ErrorMessage from 'components/widget/ErrorMessage';
import DeviceInfo from 'model/DeviceInfo';
import { EquipmentInfo } from 'model/Equipment';
import { DEVICE_MODAL_TYPE, YN_TYPE } from 'types/enumType';
import { convertDeviceTypeToString } from 'util/commonUtil';

import { equipmentInfoSchema } from './resolver/deviceResolvers';

type EquipModalProps = {
  type: DEVICE_MODAL_TYPE;
  equipment: EquipmentInfo | DeviceInfo;
  isOpen: boolean;
  isAdmin: boolean;
  onClose: () => void;
  onSubmit: (formData: EquipmentInfoRequest) => void;
};

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    padding: 0,
    border: 0,
  },
};
export default function EquipModal({
  type,
  equipment,
  isOpen,
  isAdmin,
  onClose,
  onSubmit,
}: EquipModalProps) {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm<EquipmentInfoRequest>({
    resolver: equipmentInfoSchema,
  });

  useEffect(() => {
    if (!isOpen || !equipment) {
      return;
    }

    reset({ ...equipment });
  }, [isOpen, equipment, reset]);

  return (
    <ReactModal isOpen={isOpen} style={customStyles} onRequestClose={onClose}>
      <div id={'popup-wrap'}>
        <div className={'popup-wrap device-modal'} id={'equip-modal'}>
          <div className={'popup-head'}>
            <p className={'poptit'}>{convertDeviceTypeToString(type)}</p>
          </div>
          <div className={'popup-cont'}>
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className={'cont'}>
                <div className={'filter-wrap'}>
                  <div className={'filter'}>
                    {equipment.id > 0 && (
                      <dl>
                        <dt>{'QR 코드'}</dt>
                        <dd>
                          <input type={'text'} {...register('code')} disabled />
                        </dd>
                      </dl>
                    )}
                    <dl>
                      <dt>{'설비 코드'}</dt>
                      <dd>
                        <input
                          type={'text'}
                          defaultValue={equipment.name}
                          {...register('itemCode')}
                          disabled={!isAdmin}
                        />
                      </dd>
                    </dl>
                    <dl>
                      <dt>{`${convertDeviceTypeToString(type)} 명`}</dt>
                      <dd>
                        <input
                          type={'text'}
                          defaultValue={equipment.name}
                          {...register('name')}
                          disabled={!isAdmin}
                        />
                        <input
                          type={'hidden'}
                          defaultValue={equipment.id}
                          {...register('id')}
                          disabled={!isAdmin}
                        />
                        <input
                          type={'hidden'}
                          defaultValue={type}
                          {...register('type')}
                          disabled={!isAdmin}
                        />
                      </dd>
                    </dl>
                    <dl>
                      <dt>{'코드'}</dt>
                      <dd>
                        <input
                          type={'text'}
                          defaultValue={equipment.name}
                          maxLength={10}
                          {...register('eqCd')}
                          disabled={!isAdmin}
                        />
                      </dd>
                    </dl>
                    <dl>
                      <dt>{'MDM 코드'}</dt>
                      <dd>
                        <input
                          type={'text'}
                          defaultValue={equipment.name}
                          {...register('mdmCode')}
                          disabled={!isAdmin}
                        />
                      </dd>
                    </dl>
                    {type === DEVICE_MODAL_TYPE.DEVICE && equipment.id > 0 && (
                      <dl>
                        <dt>{'사용 여부'}</dt>
                        <dd>
                          <ul className={'td-radio'}>
                            <li>
                              <input
                                type={'radio'}
                                id={'use'}
                                value={YN_TYPE.Y}
                                {...register('activate')}
                                disabled={!isAdmin}
                              />
                              <label htmlFor={'use'}>{'사용'}</label>
                            </li>
                            <li>
                              <input
                                type={'radio'}
                                id={'notUse'}
                                value={YN_TYPE.N}
                                {...register('activate')}
                                disabled={!isAdmin}
                              />
                              <label htmlFor={'notUse'}>{'미사용'}</label>
                            </li>
                          </ul>
                        </dd>
                      </dl>
                    )}
                  </div>
                </div>
                <ErrorMessage errors={errors} />

                <div className={'btn-wrap'}>
                  {isAdmin && (
                    <button type={'submit'} className={'orange_white_btn'}>
                      {'저장'}
                    </button>
                  )}
                  <button
                    type={'button'}
                    className={'gray_white_btn'}
                    onClick={onClose}
                  >
                    {'취소'}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </ReactModal>
  );
}
